import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'filter'
})
export class FilterPipe implements PipeTransform {
    transform(items: any[], searchCaption: string, searchText: string): any[] {
        if (!items) { return []; }
        if (!searchText) { return items; }
        return items.filter(item => (item[searchCaption] + '').toString().toLowerCase().indexOf(searchText.toLowerCase()) !== -1);
    }
}
